<template>
  <div class="py-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Zgjedhe llojin:</label>
    <div class="inline-block relative">
      <select
        class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
        v-model="task"
      >
        <option></option>
        <option>Problem</option>
        <option>Propozim</option>
        <option>Mbi/Nen Ngarkese</option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
    <div v-if="task === 'Problem'">
      <IssuesForm />
    </div>
    <div v-if="task === 'Propozim'">
      <PurposesForm />
    </div>
    <div v-if="task === 'Mbi/Nen Ngarkese'">
      <OverLoadFormTomorrow />
    </div>
  </div>
</template>

<script>
import IssuesForm from "../days/IssuesForm";
import PurposesForm from "../days/PurposesForm";
import OverLoadFormTomorrow from "../days/OverLoadFormTomorrow";
export default {
  components: {
    IssuesForm,
    PurposesForm,
    OverLoadFormTomorrow
  },
  data() {
    return {
      task: ""
    };
  }
};
</script>

<style>
</style>